<template>
  <div id="app">
    <form @submit.prevent="submit">
      <input type="text" v-model="comment" placeholder="Comment" />
      <br />
      <br />
      <input type="file" ref="file" />
      <br />
      <br />
      <input type="submit" value="Send" />
    </form>
    <ul>
      <li v-for="(comment, index) in comments" :key="index">
        <img
          v-if="comment.image"
          :src="comment.image"
          style="max-width: 100px"
        />
        <br />
        {{ comment.created.toDate() | moment('DD.MM.YYYY HH:mm') }}
        <br />
        {{ comment.body }}
      </li>
    </ul>
  </div>
</template>

<script>
import { firebase, commentsCollection } from '@/plugins/firebase.js'
import { uuid } from 'vue-uuid'

export default {
  data() {
    return {
      comment: '',
      comments: []
    }
  },
  mounted() {
    commentsCollection.orderBy('created', 'desc').onSnapshot(querySnapshot => {
      this.comments = []
      querySnapshot.forEach(doc => {
        this.comments.push(doc.data())
      })
    })
  },
  methods: {
    submit() {
      const file = this.$refs.file.files[0]

      var storageRef = firebase.storage().ref()
      var uploadTask = storageRef.child(`comments/${uuid.v4()}.jpg`).put(file)

      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        snapshot => {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          console.log('Upload is ' + progress + '% done')
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED:
              console.log('Upload is paused')
              break
            case firebase.storage.TaskState.RUNNING:
              console.log('Upload is running')
              break
          }
        },
        error => {
          switch (error.code) {
            case 'storage/unauthorized':
              // User doesn't have permission to access the object
              break

            case 'storage/canceled':
              // User canceled the upload
              break

            case 'storage/unknown':
              // Unknown error occurred, inspect error.serverResponse
              break
          }
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            commentsCollection
              .doc()
              .set({
                body: this.comment,
                image: downloadURL,
                created: firebase.firestore.Timestamp.now()
              })
              .then(() => {
                this.comment = ''
              })
              .catch(error => {
                console.log(error)
              })
          })
        }
      )
    }
  }
}
</script>

<style>
body {
  font-family: sans-serif;
}

ul {
  width: 320px;
  list-style: none;
  padding: 0;
}

#app {
  max-width: 900px;
  margin: 0 auto;
}
</style>
